import React from 'react';
import { DatePicker } from 'react-md/lib/Pickers';
import moment from 'moment';

import { withT } from 'lib/i18n';

import { ComponentProps } from './types';

import './SearchDateRange.scss';

export const defaultMinDate: Date = moment("20170301").startOf('day').toDate();
export const defaultMaxDate: Date = moment().endOf('day').add(90, 'days').toDate();

const SearchDateRange = (props: ComponentProps) => {
	const { t, user, beginDate, endDate, previewType } = props;
	const { onSetBeginDate, onSetEndDate } = props;

	const [minDate, maxDate] = React.useMemo(() => {
		let minDate;
		let maxDate;
		if (previewType) { // feed preview search
			// min date
			if (user.hasPermission('recovery.unrestricted_period')) {
				minDate = defaultMinDate;
			} else if (user.hasPermission('search.unrestricted_period')) {
				minDate = moment().subtract('month', 13).startOf('day').toDate();
			} else {
				minDate = moment().subtract('month', 3).startOf('day').toDate();
			}
			// max date
			if (previewType === 'print' || previewType === 'print_dmr') {
				maxDate = defaultMaxDate;
			} else {
				maxDate = moment().endOf('day').toDate(); // future dates only for print feeds
			}
		} else { // feed search, no restriction
			minDate = defaultMinDate;
			maxDate = defaultMaxDate;
		}
		return [minDate, maxDate];
	}, [previewType, user]);

	if (!beginDate || !endDate) return null;

	// Convert dates to browser timezone because date picker use it
	const beginDateTz = moment(beginDate).tz(user.settings.timezone).tz(moment.tz.guess(), true).toDate();
	const endDateTz = moment(endDate).tz(user.settings.timezone).tz(moment.tz.guess(), true).toDate();

	return (
		<div id="searchDateRange">
			<DatePicker
				id="searchDateRangeBeginDate"
				label={t("filters.period.custom.begin_date")}
				okLabel={t('filters.period.custom.dialog.ok')}
				cancelLabel={t('filters.period.custom.dialog.cancel')}
				fullWidth={false}
				portal
				icon={null}
				defaultValue={beginDateTz}
				value={beginDateTz}
				locales={user.settings.locale}
				minDate={minDate}
				maxDate={endDateTz}
				onChange={(formattedDate, date, ev) => onSetBeginDate(moment(date).tz(user.settings.timezone, true).toDate())}
			/>
			<DatePicker
				id="searchDateRangeEndDate"
				label={t("filters.period.custom.end_date")}
				okLabel={t('filters.period.custom.dialog.ok')}
				cancelLabel={t('filters.period.custom.dialog.cancel')}
				portal
				fullWidth={false}
				icon={null}
				defaultValue={endDateTz}
				value={endDateTz}
				locales={user.settings.locale}
				minDate={beginDateTz}
				maxDate={maxDate}
				onChange={(formattedDate, date, ev) => onSetEndDate(moment(date).tz(user.settings.timezone, true).endOf('day').toDate())}
			/>
		</div>
	);
};

export default withT(SearchDateRange);
